import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "../lib/api";

const SettingsCtx = createContext({ settings: null, refresh: () => {} });

export function SettingsProvider({ children }) {
    const [settings, setSettings] = useState(null);

    const refresh = useCallback(async () => {
        try {
            const { data } = await api.get("/settings");
            setSettings(data);
        } catch {
            setSettings(null);
        }
    }, []);

    useEffect(() => { refresh(); }, [refresh]);

    return <SettingsCtx.Provider value={{ settings, refresh }}>{children}</SettingsCtx.Provider>;
}

export function useSettings() {
    return useContext(SettingsCtx);
}
